<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Landing page URL:</div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-block-text
            [maxLength]="4000"
            [type]="'link'"
            [blockData]="block.variables?.['Link'] ?? ''"
            (handleOnChange)="onChange($event, 'Link')"
            [placeholder]="linkPlaceholder"
            variable="Link"
            [isPlainText]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
      </div>
    </div>
  </div>
</main>
